// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skill-used-reasoning-card {
  cursor: help;
}

.skill-used-reasoning-card:focus-visible {
  outline: 2px solid rgba(59, 130, 246, 0.55);
  outline-offset: 2px;
}

.skill-used-reasoning-popup {
  position: fixed;
  z-index: 10035;
  padding: 0.9rem;
  border: 1px solid #bfdbfe;
  border-radius: 0.7rem;
  background: #ffffff;
  color: #1f2937;
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.2);
  box-sizing: border-box;
  transform: translateX(-50%);
}

.skill-used-reasoning-popup::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 100%;
  width: 0;
  height: 0;
  transform: translateX(-50%);
  border: 0.45rem solid transparent;
  border-bottom-color: #bfdbfe;
}

.skill-used-reasoning-popup__message {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
}

.skill-used-reasoning-popup__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  border-radius: 999px;
  background: #ffffff;
}

.skill-used-reasoning-popup__avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.skill-used-reasoning-popup__message strong {
  display: block;
  margin-bottom: 0.2rem;
  font-size: 0.84rem;
}

.skill-used-reasoning-popup__message p {
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.45;
}

.skill-used-reasoning-popup--dark {
  border-color: #3b82f6;
  background: #172554;
  color: #dbeafe;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);
}

.skill-used-reasoning-popup--dark::after {
  border-bottom-color: #3b82f6;
}
`, "",{"version":3,"sources":["webpack://./src/components/report/SkillUsedReasoningCard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".skill-used-reasoning-card {\n  cursor: help;\n}\n\n.skill-used-reasoning-card:focus-visible {\n  outline: 2px solid rgba(59, 130, 246, 0.55);\n  outline-offset: 2px;\n}\n\n.skill-used-reasoning-popup {\n  position: fixed;\n  z-index: 10035;\n  padding: 0.9rem;\n  border: 1px solid #bfdbfe;\n  border-radius: 0.7rem;\n  background: #ffffff;\n  color: #1f2937;\n  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.2);\n  box-sizing: border-box;\n  transform: translateX(-50%);\n}\n\n.skill-used-reasoning-popup::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: 100%;\n  width: 0;\n  height: 0;\n  transform: translateX(-50%);\n  border: 0.45rem solid transparent;\n  border-bottom-color: #bfdbfe;\n}\n\n.skill-used-reasoning-popup__message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n}\n\n.skill-used-reasoning-popup__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 2rem;\n  width: 2rem;\n  height: 2rem;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  border-radius: 999px;\n  background: #ffffff;\n}\n\n.skill-used-reasoning-popup__avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.skill-used-reasoning-popup__message strong {\n  display: block;\n  margin-bottom: 0.2rem;\n  font-size: 0.84rem;\n}\n\n.skill-used-reasoning-popup__message p {\n  margin: 0;\n  font-size: 0.76rem;\n  line-height: 1.45;\n}\n\n.skill-used-reasoning-popup--dark {\n  border-color: #3b82f6;\n  background: #172554;\n  color: #dbeafe;\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);\n}\n\n.skill-used-reasoning-popup--dark::after {\n  border-bottom-color: #3b82f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
